module.exports = __webpack_public_path__ + "static/img/FJ@3x.426c0f5c.jpg";